import styled from "styled-components"

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 2rem;
  width: 100%;
`

export const ResumeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  & > div {
    min-width: calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    text-transform: uppercase;
    & > span.field {
      font-weight: bold;
    }
  }
`
